import {i18n} from 'src/i18n';
import Errors from 'src/modules/shared/error/errors';
import TareaService from 'src/modules/tarea/tareaService';
import listActions from 'src/modules/taskForm/list/taskFormListActions';
import Message from 'src/view/shared/message';

const prefix = 'TAREA_DESTROY';

const taskFormDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy:
    (id, deleted: any = null) =>
    async (dispatch) => {
      try {
        dispatch({
          type: taskFormDestroyActions.DESTROY_STARTED,
        });

        await TareaService.destroyAll([id]);

        dispatch({
          type: taskFormDestroyActions.DESTROY_SUCCESS,
        });

        Message.success(i18n('entities.taskForm.destroy.success'));

        dispatch(listActions.doFetchCurrentFilter());

        if (deleted) {
          deleted(id);
        } else {
          //getHistory().push('/taskForm');
        }
      } catch (error) {
        Errors.handle(error);

        dispatch(listActions.doFetchCurrentFilter());

        dispatch({
          type: taskFormDestroyActions.DESTROY_ERROR,
        });
      }
    },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: taskFormDestroyActions.DESTROY_ALL_STARTED,
      });

      await TareaService.destroyAll(ids);

      dispatch({
        type: taskFormDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(i18n('entities.taskForm.destroyAll.success'));

      //getHistory().push('/taskForm');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: taskFormDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default taskFormDestroyActions;
